import { definePreset } from '@primevue/themes';
import Aura from '@primevue/themes/aura';

// Preset customizado baseado no Aura, com superficies no estilo Sakai
export const MizunePreset = definePreset(Aura, {
    semantic: {
        primary: {
            50: '{emerald.50}',
            100: '{emerald.100}',
            200: '{emerald.200}',
            300: '{emerald.300}',
            400: '{emerald.400}',
            500: '{emerald.500}',
            600: '{emerald.600}',
            700: '{emerald.700}',
            800: '{emerald.800}',
            900: '{emerald.900}',
            950: '{emerald.950}'
        },
        colorScheme: {
            light: {
                surface: {
                    0: '#ffffff',
                    50: '{slate.50}',
                    100: '{slate.100}',
                    200: '{slate.200}',
                    300: '{slate.300}',
                    400: '{slate.400}',
                    500: '{slate.500}',
                    600: '{slate.600}',
                    700: '{slate.700}',
                    800: '{slate.800}',
                    900: '{slate.900}',
                    950: '{slate.950}'
                }
            },
            dark: {
                surface: {
                    0: '#ffffff',
                    50: '{zinc.50}',
                    100: '{zinc.100}',
                    200: '{zinc.200}',
                    300: '{zinc.300}',
                    400: '{zinc.400}',
                    500: '{zinc.500}',
                    600: '{zinc.600}',
                    700: '{zinc.700}',
                    800: '{zinc.800}',
                    900: '{zinc.900}',
                    950: '{zinc.950}'
                }
            }
        }
    },
    // botão marcado em verde (no Aura padrão o marcado e o desmarcado quase não se distinguem)
    components: {
        togglebutton: {
            colorScheme: {
                light: {
                    root: { checkedColor: '{primary.contrast.color}' },
                    content: { checkedBackground: '{primary.color}' },
                    icon: { checkedColor: '{primary.contrast.color}' }
                },
                dark: {
                    root: { checkedColor: '{primary.contrast.color}' },
                    content: { checkedBackground: '{primary.color}' },
                    icon: { checkedColor: '{primary.contrast.color}' }
                }
            }
        }
    }
});

// Opções do tema usadas no main.js (e por quem troca o preset em tempo de execução, ex.: app de vendas)
export const MizuneThemeOptions = {
    darkModeSelector: '.dark-mode',
    cssLayer: false
};
